export default __webpack_public_path__ + "static/media/icon-white.9bece226.svg";